import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  FormControlLabel,
  Tooltip,
  Switch,
  Box,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import _ from "lodash";
import { useFormik, useField } from "formik";
import * as yup from "yup";
import dayjs from "dayjs";
import { CUSTOM_CONSTANTS } from "Constants";
//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch,useSelector } from "react-redux";

//Services
import servicefaretypeapi from "Services/Servicefare";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Servicetypecreate = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );
  const [servicedetails , setservicedetails] = useState([]);
  const [addedzone , setaddedzone] = useState([]);
 // Get Services list api





 const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

   // Get Services list api
   const getServicetype = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      //console.log('res.data--->',res.data);
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setservicedetails(res?.data?.data?.data.services);
        setaddedzone(res?.data?.data?.data.addedzone);
      } else {
        setservicedetails([]);
        setaddedzone([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    servicefaretypeapi.getexcludedServicesList()
      .then(onSuccess, onFailure);
  });

 useEffect(() => {
  openDialog && getServicetype();
}, [openDialog]);

// convert day object to hh:mm:ss:A

const formatTime = (time) => {
  if (time && time.$isDayjsObject) {
    return dayjs(time).format("hh:mm:ss A");
  }
  return "Invalid Time";
};

const handleAddServicefare = (formValues) => {
  console.log('here');
  dispatch(showLoader("Loading please wait..."));

  let validatationPass = true;
  
  formValues.Daystartingtime = formValues.daystartingtime != null  ? formatTime(formValues.daystartingtime) : null
  formValues.Nightstartingtime =  formValues.nightstartingtime != null ? formatTime(formValues.nightstartingtime) :null
  formValues.Dayendingtime =  formValues.dayendingtime != null ? formatTime(formValues.dayendingtime) :null 
  formValues.Nightendingtime = formValues.nightendingtime != null ? formatTime(formValues.nightendingtime) :null
  formValues.DaystartingtimeWeekend = formValues.daystartingtimeWeekend != null ? formatTime(formValues.daystartingtimeWeekend) : null
  formValues.NightstartingtimeWeekend =formValues.nightstartingtimeWeekend != null ?  formatTime(formValues.nightstartingtimeWeekend) :null
  formValues.DayendingtimeWeekend =  formValues.dayendingtimeWeekend != null ? formatTime(formValues.dayendingtimeWeekend) :null
  formValues.NightendingtimeWeekend =  formValues.nightendingtimeWeekend != null ? formatTime(formValues.nightendingtimeWeekend) : null
  formValues.SurgeHouronestartingTime = formValues.surgeHouronestartingTime != null ? formatTime(formValues.surgeHouronestartingTime) : null
  formValues.SurgerHourtwostartingTime = formValues.surgerHourtwostartingTime != null ? formatTime(formValues.surgerHourtwostartingTime):null
  formValues.SurgeHouroneendingTime = formValues.surgeHouroneendingTime != null ? formatTime(formValues.surgeHouroneendingTime) : null
  formValues.SurgerHourtwoendingTime = formValues.surgerHourtwoendingTime != null ?  formatTime(formValues.surgerHourtwoendingTime) : null
  formValues.dayRange = "MONDAY-SUNDAY"

 // console.log('formValues-->', formValues);

  const onSuccess = (res) => {
    dispatch(hideLoader());
    if (res?.data?.status === true) {
      dispatch(
        showSnackbar({
          message: res?.data?.message || "Service Fare Created Successfully",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        })
      );

      //console.log("the response data ", res?.data);
      // setProfileDetails([]);
      formik.resetForm();
      handleClose();
      // getProfileDetails();
    }
  };
  const onFailure = (err) => {
    dispatch(hideLoader());
    dispatch(
      showSnackbar({
        message: err?.response?.data?.message || "Error while create service fare",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      })
    );
    //console.log("update profile details api", err);
  };

  if (validatationPass) {
    formValues.demoaccount_id = demoaccount_id;
    console.log(formValues);
    servicefaretypeapi.addservicefare({ ...formValues }).then(onSuccess, onFailure);
  }
};




  // Formik
  const formik = useFormik({
    initialValues: {
      servicetypes:"",
      surgeHourone: false,
      surgeHourtwo:false, 
      daystartingtime: null,
      nightstartingtime: null,
      dayendingtime: null,
      nightendingtime: null,
      daystartingtimeWeekend: null,
      nightstartingtimeWeekend: null,
      dayendingtimeWeekend: null,
      nightendingtimeWeekend: null,
      daybaseprice:"",
      nightbaseprice:"",
      daybasepriceWeekend:"",
      nightbasepriceWeekend:"",
      daydistanceprice:"",
      nightdistanceprice:"",
      daydistancepriceWeekend:"",
      nightdistancepriceWeekend:"",
      dayminuteprice:"",
      nightminuteprice:"",
      dayminutepriceWeekend:"",
      nightminutepriceWeekend:"",
      dayaddtofarepercentage:"",
      nightaddtofarepercentage:"",
      dayaddtofarepercentageWeekend:"",
      nightaddtofarepercentageWeekend:"",
      daymaximumdiscount:"",    
      nightmaximumdiscount:"",        
      daymaximumdiscountWeekend:"",    
      nightmaximumdiscountWeekend:"",        
      surgeHouronestartingTime:null,
      surgerHourtwostartingTime:null,
      surgeHouroneendingTime:null,
      surgerHourtwoendingTime:null,
      surgeHouronepercentage:"",
      surgerHourtwopercentage:"", 
      // farezone: false,
      // zonetypes: null,
      // zonepercentage: 0,
      FreeTripWaitingMinuteday:"",
      FreeTripWaitingMinutenight:"",
      WaitingPriceperminday:"",
      WaitingPriceperminnight:"",
      FreeStopsWaitingperminday:"",
      FreeStopsWaitingperminnight:"",
      StopWaitingPriceperminday:"",
      StopWaitingPriceperminnight:"",
      FreeTripWaitingMinutedayWeekend:"",
      FreeTripWaitingMinutenightWeekend:"",
      WaitingPricepermindayWeekend:"",
      WaitingPriceperminnightWeekend:"",
      FreeStopsWaitingpermindayWeekend:"",
      FreeStopsWaitingperminnightWeekend:"",
      StopWaitingPricepermindayWeekend:"",
      StopWaitingPriceperminnightWeekend:"",
      isActive:""
    },
    validationSchema: yup.object({
     servicetypes: yup.string().required("service types is required").nullable(),
   

    // surgeHourone: yup.string().required("Surge Hour (One) is required"),
    // surgeHourtwo: yup.string().required("Surge Hour (Two) is required"),
    surgeHouronestartingTime: yup
    .string()
    .when("surgeHourone", {
      is: true,
      then: yup.string().required("Surge Hour One starting time is required").nullable(),
      otherwise: yup.string().nullable(),
    }),
    surgeHouroneendingTime: yup
    .string()
    .when("surgeHourone", {
      is: true,
      then: yup.string().required("Surge Hour One Ending time is required").nullable(),
      otherwise: yup.string().nullable(),
    }),
  surgerHourtwostartingTime: yup
    .string()
    .when("surgeHourtwo", {
      is: true,
      then: yup.string().required("Surge Hour Two starting time is required").nullable(),
      otherwise: yup.string().nullable(),
    }),
  surgerHourtwoendingTime: yup
    .string()
    .when("surgeHourtwo", {
      is: true,
      then: yup.string().required("Surge Hour Two Ending time is required").nullable(),
      otherwise: yup.string().nullable(),
    }),
    daystartingtime: yup.string().required("Day starting time is required").nullable(),
    nightstartingtime: yup.string().required("Night starting time is required").nullable(),
    dayendingtime: yup.string().required("Day starting time is required").nullable(),
    nightendingtime: yup.string().required("Night ending time is required").nullable(),
    daystartingtimeWeekend: yup.string().required("Day starting time is required").nullable(),
    nightstartingtimeWeekend: yup.string().required("Night starting time is required").nullable(),
    dayendingtimeWeekend: yup.string().required("Day starting time is required").nullable(),
    nightendingtimeWeekend: yup.string().required("Night ending time is required").nullable(),
    daybaseprice: yup
      .number()
      .typeError("Day base price must be a number")
      .required("Day base price is required"),
    nightbaseprice: yup
      .number()
      .typeError("Night base price must be a number")
      .required("Night base price is required"),
     daydistanceprice: yup
      .number()
      .typeError("Day distance price must be a number")
      .required("Day distance price is required"),
    nightdistanceprice: yup
      .number()
      .typeError("Night distance price must be a number")
      .required("Night distance price is required"), 
    dayminuteprice: yup
      .number()
      .typeError("Day minute price must be a number")
      .required("Day minute price is required"),
    nightminuteprice: yup
      .number()
      .typeError("Night minute price must be a number")
      .required("Night minute price is required"),
    FreeTripWaitingMinuteday: yup
      .number()
      .typeError("Free Trip Waiting  minute day time  must be a number")
      .required("Free Trip Waiting  minute day time  is required"), 
    FreeTripWaitingMinutenight: yup
      .number()
      .typeError("Free Trip Waiting  minute Night time  must be a number")
      .required("Free Trip Waiting  minute Night time  is required"),
    WaitingPriceperminday: yup
      .number()
      .typeError(" Waiting Price day time  must be a number")
      .required("Waiting Price day time  is required"), 
    WaitingPriceperminnight: yup
      .number()
      .typeError("Waiting  Price Night time  must be a number")
      .required("Waiting Price Night time  is required"),
    FreeStopsWaitingperminday: yup
      .number()
      .typeError("Free Stops Waiting Per Min day  must be a number")
      .required("Free Stops Waiting Minute day  is required"),
    FreeStopsWaitingperminnight: yup
      .number()
      .typeError("Free Stops Waiting Per Min Night  must be a number")
      .required("Free Stops Waiting Minute  Night  is required"),
    StopWaitingPriceperminday: yup
      .number()
      .typeError("Free Stops Waiting Per Min Night  must be a number")
      .required("Free Stops Waiting Minute  Night  is required"),   
    StopWaitingPriceperminnight: yup
      .number()
      .typeError("Free Stops Waiting Per Min Night  must be a number")
      .required("Free Stops Waiting Minute  Night  is required"),
      

       FreeTripWaitingMinutedayWeekend: yup
      .number()
      .typeError("Free Trip Waiting  minute day time  must be a number")
      .required("Free Trip Waiting  minute day time  is required"), 
    FreeTripWaitingMinutenightWeekend: yup
      .number()
      .typeError("Free Trip Waiting  minute Night time  must be a number")
      .required("Free Trip Waiting  minute Night time  is required"),
    WaitingPricepermindayWeekend: yup
      .number()
      .typeError(" Waiting Price day time  must be a number")
      .required("Waiting Price day time  is required"), 
    WaitingPriceperminnightWeekend: yup
      .number()
      .typeError("Waiting  Price Night time  must be a number")
      .required("Waiting Price Night time  is required"),
    FreeStopsWaitingpermindayWeekend: yup
      .number()
      .typeError("Free Stops Waiting Per Min day  must be a number")
      .required("Free Stops Waiting Minute day  is required"),
    FreeStopsWaitingperminnightWeekend: yup
      .number()
      .typeError("Free Stops Waiting Per Min Night  must be a number")
      .required("Free Stops Waiting Minute  Night  is required"),
    StopWaitingPricepermindayWeekend: yup
      .number()
      .typeError("Free Stops Waiting Per Min Night  must be a number")
      .required("Free Stops Waiting Minute  Night  is required"),   
    StopWaitingPriceperminnightWeekend: yup
      .number()
      .typeError("Free Stops Waiting Per Min Night  must be a number")
      .required("Free Stops Waiting Minute  Night  is required"),
      
    // dayaddtofarepercentage: yup
    // .number()
    // .typeError("Day add to fare must be a number")
    // .required("Day add to fare is required"),
    // nightaddtofarepercentage: yup
    // .number()
    // .typeError("Night add to fare must be a number")
    // .required("Night add to fare is required"), 
    // daymaximumdiscount: yup
    // .number()
    // .typeError("Day maximum discount must be a number")
    // .required("Day maximum discount is required"),
    // nightmaximumdiscount: yup
    // .number()
    // .typeError("Night maximum discount must be a number")
    // .required("Night maximum discount is required"),  
    daybasepriceWeekend: yup
      .number()
      .typeError("Day base price must be a number")
      .required("Day base price is required"),
    nightbasepriceWeekend: yup
      .number()
      .typeError("Night base price must be a number")
      .required("Night base price is required"),
     daydistancepriceWeekend: yup
      .number()
      .typeError("Day distance price must be a number")
      .required("Day distance price is required"),
    nightdistancepriceWeekend: yup
      .number()
      .typeError("Night distance price must be a number")
      .required("Night distance price is required"), 
    dayminutepriceWeekend: yup
      .number()
      .typeError("Day minute price must be a number")
      .required("Day minute price is required"),
    nightminutepriceWeekend: yup
      .number()
      .typeError("Night minute price must be a number")
      .required("Night minute price is required"),
    // dayaddtofarepercentageWeekend: yup
    // .number()
    // .typeError("Day add to fare must be a number")
    // .required("Day add to fare is required"),
    // nightaddtofarepercentageWeekend: yup
    // .number()
    // .typeError("Night add to fare must be a number")
    // .required("Night add to fare is required"), 
    // daymaximumdiscountWeekend: yup
    // .number()
    // .typeError("Day maximum discount must be a number")
    // .required("Day maximum discount is required"),
    // nightmaximumdiscountWeekend: yup
    // .number()
    // .typeError("Night maximum discount must be a number")
    // .required("Night maximum discount is required"),  
    // surgeHouronestartingTime: yup
    // .string().required("Surge Hour One starting time is required").nullable(),
    // surgerHourtwostartingTime: yup
    // .string().required("Surge Hour Two starting time is required").nullable(),
    // surgeHouroneendingTime: yup
    // .string().required("Surge Hour One ending time is required").nullable(),
    // surgerHourtwoendingTime: yup
    // .string().required("Surge Hour Two ending time is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleAddServicefare,
  });

  

  //Tabs

  return (
    <>
<Dialog
open={openDialog}
TransitionComponent={Transition}
keepMounted
onClose={handleClose}
maxWidth={"xl"}
aria-describedby="dialog-box"
className={classes.root}
>
<DialogTitle>
<section className={classes.dialogTitleContainer}>
<Typography variant="body1" className={classes.title}>
  Add Fare model
</Typography>
<IconButton aria-label="close" onClick={handleClose}>
  <CloseIcon className={classes.closeIcon} />
</IconButton>
</section>
</DialogTitle>

<DialogContent>

<Grid container spacing={3} rowSpacing={4} columnSpacing={4} className={classes.detailsContainer} >

{/* service details feilds */}

<Grid item xs={2} className={classes.detailsContent}>
<TextField
name="servicetypes"
id="servicetypes"
label="Service Types"
value={formik?.values?.servicetypes}
defaultValue={formik?.values?.servicetypes}
onChange={formik.handleChange}
select
error={
formik?.errors?.servicetypes &&
formik?.touched?.servicetypes
}
helperText={
formik?.errors?.servicetypes &&
formik?.touched?.servicetypes &&
formik?.errors?.servicetypes
}
fullWidth
variant="outlined"
size="small"
>
{servicedetails.map((service) => (
<MenuItem
  key={service.serviceName}
  value={service._id}
>
  {`${service.serviceName}`}
</MenuItem>
))}
</TextField>
</Grid>

{/* <Grid item xs={4} className={classes.detailsContent} >
<TextField
name="farezone"
id="farezone"
label="Zone fare"
value={formik?.values?.farezone}
defaultValue={formik?.values?.farezone}
onChange={formik.handleChange}
select
error={
formik?.errors?.farezone &&
formik?.touched?.farezone
}
helperText={
formik?.errors?.farezone &&
formik?.touched?.farezone &&
formik?.errors?.farezone
}
fullWidth
variant="outlined"
size="small"
>

<MenuItem
  key="true"
  value={true}
>
  ENABLE
</MenuItem>

<MenuItem
  key="false"
  value={false}
>
  DISABLE
</MenuItem>
</TextField>
</Grid>  */}

{/* <Grid
  item
  xs={3}
  style={{
    display: "flex",
    alignItems: "center",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
    borderRadius: "10px",
    padding:"10px",
    background: "#fff",
    justifyContent: "space-evenly",
  }}
> */}
  {/* Label */}
  {/* <Typography
    variant="subtitle1"
    style={{
      fontWeight: "bold",
      textTransform: "uppercase",
      fontSize: "14px",
      color: "#333",
    }}
  >
    Zone Fare :
  </Typography> */}

  {/* Switch */}
  {/* <FormControlLabel
    control={
      <Switch
        checked={formik.values.farezone === true}
        onChange={(e) =>{
          formik.setFieldValue("farezone", e.target.checked);
    if (!e.target.checked) {
      formik.setFieldValue("zonetypes", null);
      formik.setFieldValue("zonepercentage", 0);
    }
        }}
        color="primary"
        sx={{
          transform: "scale(1.1)",
          "& .MuiSwitch-switchBase.Mui-checked": { color: "#4caf50" },
          "& .MuiSwitch-track": { backgroundColor: "#bdbdbd" },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#4caf50",
          }
        }}
      />
    }
    label={formik.values.farezone ? "ENABLE" : "DISABLE"}
    sx={{
      margin: 0,
      fontWeight: "bold",
      color: formik.values.farezone ? "#4caf50" : "#f44336",
      textTransform: "uppercase",
    }}
  /> */}
{/* </Grid> */}

{/* <Grid item xs={4} className={classes.detailsContent} >
<TextField
name="surgeHourone"
id="surgeHourone"
label="Surge Hour (One)"
value={formik?.values?.surgeHourone}
defaultValue={formik?.values?.surgeHourone}
onChange={formik.handleChange}
select
error={
formik?.errors?.surgeHourone &&
formik?.touched?.surgeHourone
}
helperText={
formik?.errors?.surgeHourone &&
formik?.touched?.surgeHourone &&
formik?.errors?.surgeHourone
}
fullWidth
variant="outlined"
size="small"
>

<MenuItem
  key="true"
  value={true}
>
  ENABLE
</MenuItem>

<MenuItem
  key="false"
  value={false}
>
  DISABLE
</MenuItem>
</TextField>
</Grid>

<Grid item xs={4} className={classes.detailsContent}>
<TextField
name="surgeHourtwo"
id="surgeHourtwo"
label="Surge Hour (Two)"
value={formik?.values?.surgeHourtwo}
defaultValue={formik?.values?.surgeHourtwo}
onChange={formik.handleChange}
select
error={
formik?.errors?.surgeHourtwo &&
formik?.touched?.surgeHourtwo
}
helperText={
formik?.errors?.surgeHourtwo &&
formik?.touched?.surgeHourtwo &&
formik?.errors?.surgeHourtwo
}
fullWidth
variant="outlined"
size="small"
>

<MenuItem
  key="true"
  value={true}
>
  ENABLE
</MenuItem>

<MenuItem
  key="false"
  value={false}
>
  DISABLE
</MenuItem>
</TextField>
</Grid> */}

<Grid
  item
  xs={3}
  style={{
    display: "flex",
    alignItems: "center",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
    borderRadius: "10px",
    padding:"10px",
    background: "#fff",
    justifyContent: "space-evenly",
     margin:"2px"
  }}
>
  {/* Label */}
  <Typography
    variant="subtitle1"
    style={{
      fontWeight: "bold",
      textTransform: "uppercase",
      fontSize: "14px",
      color: "#333",
    }}
  >
    Surge Hour 1 :
  </Typography>

  {/* Switch */}
  <FormControlLabel
    control={
      <Switch
        checked={formik.values.surgeHourone === true} // Use surgeHourone
        onChange={(e) =>{
          formik.setFieldValue("surgeHourone", e.target.checked); // Set surgeHourone
          // OPTIONAL: Reset dependent fields if disabled
          // if (!e.target.checked) {
          //   formik.setFieldValue("surgeHouronestartingTime", null);
          //   formik.setFieldValue("surgeHouroneendingTime", null);
          //   formik.setFieldValue("surgeHouronepercentage", "");
          // }
        }}
        color="primary"
        sx={{
          transform: "scale(1.1)",
          "& .MuiSwitch-switchBase.Mui-checked": { color: "#ff9800" }, // Different color for surge?
          "& .MuiSwitch-track": { backgroundColor: "#bdbdbd" },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#ff9800",
          }
        }}
      />
    }
    label={formik.values.surgeHourone ? "ENABLE" : "DISABLE"}
    sx={{
      margin: 0,
      fontWeight: "bold",
      color: formik.values.surgeHourone ? "#ff9800" : "#f44336",
      textTransform: "uppercase",
    }}
  />

</Grid>

<Grid
  item
  xs={3} // Adjust xs value as needed based on your layout
  style={{
    display: "flex",
    alignItems: "center",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
    borderRadius: "10px",
    padding:"10px",
    background: "#fff",
    justifyContent: "space-evenly",
    margin:"2px"
  }}
>
  {/* Label */}
  <Typography
    variant="subtitle1"
    style={{
      fontWeight: "bold",
      textTransform: "uppercase",
      fontSize: "14px",
      color: "#333",
    }}
  >
    Surge Hour 2 :
  </Typography>

  {/* Switch */}
  <FormControlLabel
    control={
      <Switch
        checked={formik.values.surgeHourtwo === true} // Use surgeHourtwo
        onChange={(e) =>{
          formik.setFieldValue("surgeHourtwo", e.target.checked); // Set surgeHourtwo
          // OPTIONAL: Reset dependent fields if disabled
          // if (!e.target.checked) {
          //   formik.setFieldValue("surgerHourtwostartingTime", null);
          //   formik.setFieldValue("surgerHourtwoendingTime", null);
          //   formik.setFieldValue("surgerHourtwopercentage", "");
          // }
        }}
        color="primary"
        sx={{
          transform: "scale(1.1)",
          "& .MuiSwitch-switchBase.Mui-checked": { color: "#ff9800" }, // Different color for surge?
          "& .MuiSwitch-track": { backgroundColor: "#bdbdbd" },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#ff9800",
          }
        }}
      />
    }
    label={formik.values.surgeHourtwo ? "ENABLE" : "DISABLE"}
    sx={{
      margin: 0,
      fontWeight: "bold",
      color: formik.values.surgeHourtwo ? "#ff9800" : "#f44336",
      textTransform: "uppercase",
    }}
  />
</Grid>

<Grid
  item
  xs={3} // Adjust xs value as needed based on your layout
  style={{
    display: "flex",
    alignItems: "center",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
    borderRadius: "10px",
    padding:"10px",
    background: "#fff",
    justifyContent: "space-evenly",
    margin:"2px"
  }}
>
  {/* Label */}
  <Typography
    variant="subtitle1"
    style={{
      fontWeight: "bold",
      textTransform: "uppercase",
      fontSize: "14px",
      color: "#333",
    }}
  >
    Active Button
  </Typography>

  {/* Switch */}
  <FormControlLabel
    control={
      <Switch
        checked={formik.values.isActive === true} 
        onChange={(e) =>{
          formik.setFieldValue("isActive", e.target.checked); 
          // OPTIONAL: Reset dependent fields if disabled
          // if (!e.target.checked) {
          //   formik.setFieldValue("surgerHourtwostartingTime", null);
          //   formik.setFieldValue("surgerHourtwoendingTime", null);
          //   formik.setFieldValue("surgerHourtwopercentage", "");
          // }
        }}
        color="primary"
        sx={{
          transform: "scale(1.1)",
          "& .MuiSwitch-switchBase.Mui-checked": { color: "#ff9800" }, // Different color for surge?
          "& .MuiSwitch-track": { backgroundColor: "#bdbdbd" },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#ff9800",
          }
        }}
      />
    }
    label={formik.values.isActive ? "ACTIVE" : "INACTIVE"}
    sx={{
      margin: 0,
      fontWeight: "bold",
      color: formik.values.isActive ? "#ff9800" : "#f44336",
      textTransform: "uppercase",
    }}
  />
</Grid>

</Grid>

<Grid container spacing={3} rowSpacing={4} columnSpacing={3} className={classes.tarrifContainer}>

<Grid item xs={12}>

 
        <Grid item xs={12} style={{paddingTop:40,paddingBottom:40}}>
<Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }} >{"MONDAY - THURSDAY TARIFF"}</Typography>
</Grid>
        <Grid container spacing={3} rowSpacing={4} columnSpacing={3}>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Starting Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<Typography variant="h6" className={classes.tarrifsubheadings} >Day time</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.daystartingtime}
            onChange={(newValue) => formik.setFieldValue("daystartingtime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.daystartingtime &&
              formik?.touched?.daystartingtime
              }
              helperText={
              formik?.errors?.daystartingtime &&
              formik?.touched?.daystartingtime &&
              formik?.errors?.daystartingtime
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<Typography variant="h6"  className={classes.tarrifsubheadings}>Night time</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.nightstartingtime}
            onChange={(newValue) => formik.setFieldValue("nightstartingtime", newValue)}
            renderInput={(params) => <TextField {...params}  
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.nightstartingtime &&
              formik?.touched?.nightstartingtime
              }
              helperText={
              formik?.errors?.nightstartingtime &&
              formik?.touched?.nightstartingtime &&
              formik?.errors?.nightstartingtime
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Ending Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.dayendingtime}
            onChange={(newValue) => formik.setFieldValue("dayendingtime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.dayendingtime &&
              formik?.touched?.dayendingtime
              }
              helperText={
              formik?.errors?.dayendingtime &&
              formik?.touched?.dayendingtime &&
              formik?.errors?.dayendingtime
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.nightendingtime}
            onChange={(newValue) => formik.setFieldValue("nightendingtime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.nightendingtime &&
              formik?.touched?.nightendingtime
              }
              helperText={
              formik?.errors?.nightendingtime &&
              formik?.touched?.nightendingtime &&
              formik?.errors?.nightendingtime
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography> 
</Grid>
  <Grid item xs={4}>
  <TextField
name="daybaseprice"
id="daybaseprice"
label="Base price"
value={formik?.values?.daybaseprice}
defaultValue={formik?.values?.daybaseprice}
onChange={formik.handleChange}
error={
formik?.errors?.daybaseprice &&
formik?.touched?.daybaseprice
}
helperText={
formik?.errors?.daybaseprice &&
formik?.touched?.daybaseprice &&
formik?.errors?.daybaseprice
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightbaseprice"
id="nightbaseprice"
label="Base price"
value={formik?.values?.nightbaseprice}
defaultValue={formik?.values?.nightbaseprice}
onChange={formik.handleChange}
error={
formik?.errors?.nightbaseprice &&
formik?.touched?.nightbaseprice
}
helperText={
formik?.errors?.nightbaseprice &&
formik?.touched?.nightbaseprice &&
formik?.errors?.nightbaseprice
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Distance Price / KM ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="daydistanceprice"
id="daydistanceprice"
label="Distance price"
value={formik?.values?.daydistanceprice}
defaultValue={formik?.values?.daydistanceprice}
onChange={formik.handleChange}
error={
formik?.errors?.daydistanceprice &&
formik?.touched?.daydistanceprice
}
helperText={
formik?.errors?.daydistanceprice &&
formik?.touched?.daydistanceprice &&
formik?.errors?.daydistanceprice
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightdistanceprice"
id="nightdistanceprice"
label="Distance price"
value={formik?.values?.nightdistanceprice}
defaultValue={formik?.values?.nightdistanceprice}
onChange={formik.handleChange}
error={
formik?.errors?.nightdistanceprice &&
formik?.touched?.nightdistanceprice
}
helperText={
formik?.errors?.nightdistanceprice &&
formik?.touched?.nightdistanceprice &&
formik?.errors?.nightdistanceprice
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>



<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Minute Price / Minute ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="dayminuteprice"
id="dayminuteprice"
label="Minute price"
value={formik?.values?.dayminuteprice}
defaultValue={formik?.values?.dayminuteprice}
onChange={formik.handleChange}
error={
formik?.errors?.dayminuteprice &&
formik?.touched?.dayminuteprice
}
helperText={
formik?.errors?.dayminuteprice &&
formik?.touched?.dayminuteprice &&
formik?.errors?.dayminuteprice
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightminuteprice"
id="nightminuteprice"
label="Minute price"
value={formik?.values?.nightminuteprice}
defaultValue={formik?.values?.nightminuteprice}
onChange={formik.handleChange}
error={
formik?.errors?.nightminuteprice &&
formik?.touched?.nightminuteprice
}
helperText={
formik?.errors?.nightminuteprice &&
formik?.touched?.nightminuteprice &&
formik?.errors?.nightminuteprice
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>


<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >
Free Trip Waiting per min  ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="FreeTripWaitingMinuteday"
id="FreeTripWaitingMinuteday"
label="Free Waiting Minute "
value={formik?.values?.FreeTripWaitingMinuteday}
defaultValue={formik?.values?.FreeTripWaitingMinuteday}
onChange={formik.handleChange}
error={
formik?.errors?.FreeTripWaitingMinuteday &&
formik?.touched?.FreeTripWaitingMinuteday
}
helperText={
formik?.errors?.FreeTripWaitingMinuteday &&
formik?.touched?.FreeTripWaitingMinuteday &&
formik?.errors?.FreeTripWaitingMinuteday
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="FreeTripWaitingMinutenight"
id="FreeTripWaitingMinutenight"
label="Free Waiting Minute "
value={formik?.values?.FreeTripWaitingMinutenight}
defaultValue={formik?.values?.FreeTripWaitingMinutenight}
onChange={formik.handleChange}
error={
formik?.errors?.FreeTripWaitingMinutenight &&
formik?.touched?.FreeTripWaitingMinutenight
}
helperText={
formik?.errors?.FreeTripWaitingMinutenight &&
formik?.touched?.FreeTripWaitingMinutenight &&
formik?.errors?.FreeTripWaitingMinutenight
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >
Waiting Price  per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="WaitingPriceperminday"
id="WaitingPriceperminday"
label="Waiting Price "
value={formik?.values?.WaitingPriceperminday}
defaultValue={formik?.values?.WaitingPriceperminday}
onChange={formik.handleChange}
error={
formik?.errors?.WaitingPriceperminday &&
formik?.touched?.WaitingPriceperminday
}
helperText={
formik?.errors?.WaitingPriceperminday &&
formik?.touched?.WaitingPriceperminday &&
formik?.errors?.WaitingPriceperminday
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="WaitingPriceperminnight"
id="WaitingPriceperminnight"
label=" Waiting Price "
value={formik?.values?.WaitingPriceperminnight}
defaultValue={formik?.values?.WaitingPriceperminnight}
onChange={formik.handleChange}
error={
formik?.errors?.WaitingPriceperminnight &&
formik?.touched?.WaitingPriceperminnight
}
helperText={
formik?.errors?.WaitingPriceperminnight &&
formik?.touched?.WaitingPriceperminnight &&
formik?.errors?.WaitingPriceperminnight
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>



<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >
Free Stops Waiting per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="FreeStopsWaitingperminday"
id="FreeStopsWaitingperminday"
label="Free Stops Waiting Per Min "
value={formik?.values?.FreeStopsWaitingperminday}
defaultValue={formik?.values?.FreeStopsWaitingperminday}
onChange={formik.handleChange}
error={
formik?.errors?.FreeStopsWaitingperminday &&
formik?.touched?.FreeStopsWaitingperminday
}
helperText={
formik?.errors?.FreeStopsWaitingperminday &&
formik?.touched?.FreeStopsWaitingperminday &&
formik?.errors?.FreeStopsWaitingperminday
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="FreeStopsWaitingperminnight"
id="FreeStopsWaitingperminnight"
label="Free Stops Waiting Per Min"
value={formik?.values?.FreeStopsWaitingperminnight}
defaultValue={formik?.values?.FreeStopsWaitingperminnight}
onChange={formik.handleChange}
error={
formik?.errors?.FreeStopsWaitingperminnight &&
formik?.touched?.FreeStopsWaitingperminnight
}
helperText={
formik?.errors?.FreeStopsWaitingperminnight &&
formik?.touched?.FreeStopsWaitingperminnight &&
formik?.errors?.FreeStopsWaitingperminnight
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>


  <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >
Stop Waiting Price  per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="StopWaitingPriceperminday"
id="StopWaitingPriceperminday"
label="Stop Waiting Price "
value={formik?.values?.StopWaitingPriceperminday}
defaultValue={formik?.values?.StopWaitingPriceperminday}
onChange={formik.handleChange}
error={
formik?.errors?.StopWaitingPriceperminday &&
formik?.touched?.StopWaitingPriceperminday
}
helperText={
formik?.errors?.StopWaitingPriceperminday &&
formik?.touched?.StopWaitingPriceperminday &&
formik?.errors?.StopWaitingPriceperminday
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="StopWaitingPriceperminnight"
id="StopWaitingPriceperminnight"
label="Stop Waiting Price "
value={formik?.values?.StopWaitingPriceperminnight}
defaultValue={formik?.values?.StopWaitingPriceperminnight}
onChange={formik.handleChange}
error={
formik?.errors?.StopWaitingPriceperminnight &&
formik?.touched?.StopWaitingPriceperminnight
}
helperText={
formik?.errors?.StopWaitingPriceperminnight &&
formik?.touched?.StopWaitingPriceperminnight &&
formik?.errors?.StopWaitingPriceperminnight
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>



  {/* <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Add to Fare in ( % ) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="dayaddtofarepercentage"
id="dayaddtofarepercentage"
label="Add to fare"
value={formik?.values?.dayaddtofarepercentage}
defaultValue={formik?.values?.dayaddtofarepercentage}
onChange={formik.handleChange}
error={
formik?.errors?.dayaddtofarepercentage &&
formik?.touched?.dayaddtofarepercentage
}
helperText={
formik?.errors?.dayaddtofarepercentage &&
formik?.touched?.dayaddtofarepercentage &&
formik?.errors?.dayaddtofarepercentage
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightaddtofarepercentage"
id="nightaddtofarepercentage"
label="Add to fare"
value={formik?.values?.nightaddtofarepercentage}
defaultValue={formik?.values?.nightaddtofarepercentage}
onChange={formik.handleChange}
error={
formik?.errors?.nightaddtofarepercentage &&
formik?.touched?.nightaddtofarepercentage
}
helperText={
formik?.errors?.nightaddtofarepercentage &&
formik?.touched?.nightaddtofarepercentage &&
formik?.errors?.nightaddtofarepercentage
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid> */}

{/*Maximum discount*/}

  {/* <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Maximum discount ( % ) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="daymaximumdiscount"
id="daymaximumdiscount"
label="Maximum discount"
value={formik?.values?.daymaximumdiscount}
defaultValue={formik?.values?.daymaximumdiscount}
onChange={formik.handleChange}
error={
formik?.errors?.daymaximumdiscount &&
formik?.touched?.daymaximumdiscount
}
helperText={
formik?.errors?.daymaximumdiscount &&
formik?.touched?.daymaximumdiscount &&
formik?.errors?.daymaximumdiscount
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightmaximumdiscount"
id="nightmaximumdiscount"
label="Maximum discount"
value={formik?.values?.nightmaximumdiscount}
defaultValue={formik?.values?.nightmaximumdiscount}
onChange={formik.handleChange}
error={
formik?.errors?.nightmaximumdiscount &&
formik?.touched?.nightmaximumdiscount
}
helperText={
formik?.errors?.nightmaximumdiscount &&
formik?.touched?.nightmaximumdiscount &&
formik?.errors?.nightmaximumdiscount
}
fullWidth
variant="outlined"
size="small"
></TextField>


  </Grid> */}


        </Grid>
     
         <Grid item xs={12} style={{paddingTop:50,paddingBottom:50}}>
<Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }} >{"FRIDAY - SUNDAY TARIFF"}</Typography>
</Grid>
        <Grid container spacing={3} rowSpacing={4} columnSpacing={3}>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Starting Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<Typography variant="h6" className={classes.tarrifsubheadings} >Day time</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection

            value={formik?.values?.daystartingtimeWeekend}
            onChange={(newValue) => formik.setFieldValue("daystartingtimeWeekend", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.daystartingtimeWeekend &&
              formik?.touched?.daystartingtimeWeekend
              }
              helperText={
              formik?.errors?.daystartingtimeWeekend &&
              formik?.touched?.daystartingtimeWeekend &&
              formik?.errors?.daystartingtimeWeekend
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<Typography variant="h6"  className={classes.tarrifsubheadings}>Night time</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.nightstartingtimeWeekend}
            onChange={(newValue) => formik.setFieldValue("nightstartingtimeWeekend", newValue)}
            renderInput={(params) => <TextField {...params}  
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.nightstartingtimeWeekend &&
              formik?.touched?.nightstartingtimeWeekend
              }
              helperText={
              formik?.errors?.nightstartingtimeWeekend &&
              formik?.touched?.nightstartingtimeWeekend &&
              formik?.errors?.nightstartingtimeWeekend
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Ending Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.dayendingtimeWeekend}
            onChange={(newValue) => formik.setFieldValue("dayendingtimeWeekend", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.dayendingtimeWeekend &&
              formik?.touched?.dayendingtimeWeekend
              }
              helperText={
              formik?.errors?.dayendingtimeWeekend &&
              formik?.touched?.dayendingtimeWeekend &&
              formik?.errors?.dayendingtimeWeekend
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.nightendingtimeWeekend}
            onChange={(newValue) => formik.setFieldValue("nightendingtimeWeekend", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.nightendingtimeWeekend &&
              formik?.touched?.nightendingtimeWeekend
              }
              helperText={
              formik?.errors?.nightendingtimeWeekend &&
              formik?.touched?.nightendingtimeWeekend &&
              formik?.errors?.nightendingtimeWeekend
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography> 
</Grid>
  <Grid item xs={4}>
  <TextField
name="daybasepriceWeekend"
id="daybasepriceWeekend"
label="Base price"
value={formik?.values?.daybasepriceWeekend}
defaultValue={formik?.values?.daybasepriceWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.daybasepriceWeekend &&
formik?.touched?.daybasepriceWeekend
}
helperText={
formik?.errors?.daybasepriceWeekend &&
formik?.touched?.daybasepriceWeekend &&
formik?.errors?.daybasepriceWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightbasepriceWeekend"
id="nightbasepriceWeekend"
label="Base price"
value={formik?.values?.nightbasepriceWeekend}
defaultValue={formik?.values?.nightbasepriceWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.nightbasepriceWeekendWeekend &&
formik?.touched?.nightbasepriceWeekendWeekend
}
helperText={
formik?.errors?.nightbasepriceWeekendWeekend &&
formik?.touched?.nightbasepriceWeekendWeekend &&
formik?.errors?.nightbasepriceWeekendWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Distance Price / KM ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="daydistancepriceWeekend"
id="daydistancepriceWeekend"
label="Distance price"
value={formik?.values?.daydistancepriceWeekend}
defaultValue={formik?.values?.daydistancepriceWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.daydistancepriceWeekend &&
formik?.touched?.daydistancepriceWeekend
}
helperText={
formik?.errors?.daydistancepriceWeekend &&
formik?.touched?.daydistancepriceWeekend &&
formik?.errors?.daydistancepriceWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightdistancepriceWeekend"
id="nightdistancepriceWeekend"
label="Distance price"
value={formik?.values?.nightdistancepriceWeekend}
defaultValue={formik?.values?.nightdistancepriceWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.nightdistancepriceWeekend &&
formik?.touched?.nightdistancepriceWeekend
}
helperText={
formik?.errors?.nightdistancepriceWeekend &&
formik?.touched?.nightdistancepriceWeekend &&
formik?.errors?.nightdistancepriceWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>



<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Minute Price / Minute ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="dayminutepriceWeekend"
id="dayminutepriceWeekend"
label="Minute price"
value={formik?.values?.dayminutepriceWeekend}
defaultValue={formik?.values?.dayminutepriceWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.dayminutepriceWeekendWeekend &&
formik?.touched?.dayminutepriceWeekendWeekend
}
helperText={
formik?.errors?.dayminutepriceWeekendWeekend &&
formik?.touched?.dayminutepriceWeekendWeekend &&
formik?.errors?.dayminutepriceWeekendWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightminutepriceWeekend"
id="nightminutepriceWeekend"
label="Minute price"
value={formik?.values?.nightminutepriceWeekend}
defaultValue={formik?.values?.nightminutepriceWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.nightminutepriceWeekend &&
formik?.touched?.nightminutepriceWeekend
}
helperText={
formik?.errors?.nightminutepriceWeekend &&
formik?.touched?.nightminutepriceWeekend &&
formik?.errors?.nightminutepriceWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>





<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >
Free Trip Waiting per min  ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="FreeTripWaitingMinutedayWeekend"
id="FreeTripWaitingMinutedayWeekend"
label="Free Waiting Minute "
value={formik?.values?.FreeTripWaitingMinutedayWeekend}
defaultValue={formik?.values?.FreeTripWaitingMinutedayWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.FreeTripWaitingMinutedayWeekend &&
formik?.touched?.FreeTripWaitingMinutedayWeekend
}
helperText={
formik?.errors?.FreeTripWaitingMinutedayWeekend &&
formik?.touched?.FreeTripWaitingMinutedayWeekend &&
formik?.errors?.FreeTripWaitingMinutedayWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="FreeTripWaitingMinutenightWeekend"
id="FreeTripWaitingMinutenightWeekend"
label="Free Waiting Minute "
value={formik?.values?.FreeTripWaitingMinutenightWeekend}
defaultValue={formik?.values?.FreeTripWaitingMinutenightWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.FreeTripWaitingMinutenightWeekend &&
formik?.touched?.FreeTripWaitingMinutenightWeekend
}
helperText={
formik?.errors?.FreeTripWaitingMinutenightWeekend &&
formik?.touched?.FreeTripWaitingMinutenightWeekend &&
formik?.errors?.FreeTripWaitingMinutenightWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >
Waiting Price  per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="WaitingPricepermindayWeekend"
id="WaitingPricepermindayWeekend"
label="Waiting Price "
value={formik?.values?.WaitingPricepermindayWeekend}
defaultValue={formik?.values?.WaitingPricepermindayWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.WaitingPricepermindayWeekend &&
formik?.touched?.WaitingPricepermindayWeekend
}
helperText={
formik?.errors?.WaitingPricepermindayWeekend &&
formik?.touched?.WaitingPricepermindayWeekend &&
formik?.errors?.WaitingPricepermindayWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="WaitingPriceperminnightWeekend"
id="WaitingPriceperminnightWeekend"
label=" Waiting Price "
value={formik?.values?.WaitingPriceperminnightWeekend}
defaultValue={formik?.values?.WaitingPriceperminnightWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.WaitingPriceperminnightWeekend &&
formik?.touched?.WaitingPriceperminnightWeekend
}
helperText={
formik?.errors?.WaitingPriceperminnightWeekend &&
formik?.touched?.WaitingPriceperminnightWeekend &&
formik?.errors?.WaitingPriceperminnightWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>



<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >
Free Stops Waiting per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="FreeStopsWaitingpermindayWeekend"
id="FreeStopsWaitingpermindayWeekend"
label="Free Stops Waiting Per Min "
value={formik?.values?.FreeStopsWaitingpermindayWeekend}
defaultValue={formik?.values?.FreeStopsWaitingpermindayWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.FreeStopsWaitingpermindayWeekend &&
formik?.touched?.FreeStopsWaitingpermindayWeekend
}
helperText={
formik?.errors?.FreeStopsWaitingpermindayWeekend &&
formik?.touched?.FreeStopsWaitingpermindayWeekend &&
formik?.errors?.FreeStopsWaitingpermindayWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="FreeStopsWaitingperminnightWeekend"
id="FreeStopsWaitingperminnightWeekend"
label="Free Stops Waiting Per Min"
value={formik?.values?.FreeStopsWaitingperminnightWeekend}
defaultValue={formik?.values?.FreeStopsWaitingperminnightWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.FreeStopsWaitingperminnightWeekend &&
formik?.touched?.FreeStopsWaitingperminnightWeekend
}
helperText={
formik?.errors?.FreeStopsWaitingperminnightWeekend &&
formik?.touched?.FreeStopsWaitingperminnightWeekend &&
formik?.errors?.FreeStopsWaitingperminnightWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>


  <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >
Stop Waiting Price  per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="StopWaitingPricepermindayWeekend"
id="StopWaitingPricepermindayWeekend"
label="Stop Waiting Price "
value={formik?.values?.StopWaitingPricepermindayWeekend}
defaultValue={formik?.values?.StopWaitingPricepermindayWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.StopWaitingPricepermindayWeekend &&
formik?.touched?.StopWaitingPricepermindayWeekend
}
helperText={
formik?.errors?.StopWaitingPricepermindayWeekend &&
formik?.touched?.StopWaitingPricepermindayWeekend &&
formik?.errors?.StopWaitingPricepermindayWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="StopWaitingPriceperminnightWeekend"
id="StopWaitingPriceperminnightWeekend"
label="Stop Waiting Price "
value={formik?.values?.StopWaitingPriceperminnightWeekend}
defaultValue={formik?.values?.StopWaitingPriceperminnightWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.StopWaitingPriceperminnightWeekend &&
formik?.touched?.StopWaitingPriceperminnightWeekend
}
helperText={
formik?.errors?.StopWaitingPriceperminnightWeekend &&
formik?.touched?.StopWaitingPriceperminnightWeekend &&
formik?.errors?.StopWaitingPriceperminnightWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>



  {/* <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Add to Fare in ( % ) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="dayaddtofarepercentageWeekend"
id="dayaddtofarepercentageWeekend"
label="Add to fare"
value={formik?.values?.dayaddtofarepercentageWeekend}
defaultValue={formik?.values?.dayaddtofarepercentageWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.dayaddtofarepercentageWeekend &&
formik?.touched?.dayaddtofarepercentageWeekend
}
helperText={
formik?.errors?.dayaddtofarepercentageWeekend &&
formik?.touched?.dayaddtofarepercentageWeekend &&
formik?.errors?.dayaddtofarepercentageWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightaddtofarepercentageWeekend"
id="nightaddtofarepercentageWeekend"
label="Add to fare"
value={formik?.values?.nightaddtofarepercentageWeekend}
defaultValue={formik?.values?.nightaddtofarepercentageWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.nightaddtofarepercentageWeekend &&
formik?.touched?.nightaddtofarepercentageWeekend
}
helperText={
formik?.errors?.nightaddtofarepercentageWeekend &&
formik?.touched?.nightaddtofarepercentageWeekend &&
formik?.errors?.nightaddtofarepercentageWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid> */}

{/*Maximum discount*/}

  {/* <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Maximum discount ( % ) : </Typography>  
</Grid>
<Grid item xs={4}>
  <TextField
name="daymaximumdiscountWeekend"
id="daymaximumdiscountWeekend"
label="Maximum discount"
value={formik?.values?.daymaximumdiscountWeekend}
defaultValue={formik?.values?.daymaximumdiscountWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.daymaximumdiscountWeekend &&
formik?.touched?.daymaximumdiscountWeekend
}
helperText={
formik?.errors?.daymaximumdiscountWeekend &&
formik?.touched?.daymaximumdiscountWeekend &&
formik?.errors?.daymaximumdiscountWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightmaximumdiscountWeekend"
id="nightmaximumdiscountWeekend"
label="Maximum discount"
value={formik?.values?.nightmaximumdiscountWeekend}
defaultValue={formik?.values?.nightmaximumdiscountWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.nightmaximumdiscountWeekend &&
formik?.touched?.nightmaximumdiscountWeekend
}
helperText={
formik?.errors?.nightmaximumdiscountWeekend &&
formik?.touched?.nightmaximumdiscountWeekend &&
formik?.errors?.nightmaximumdiscountWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>


  </Grid> */}







        </Grid>
    
     
</Grid>
{/* <Grid item xs={12}>
<Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }} >{"MONDAY - SUNDAY TARIFF"}</Typography>
</Grid> */}



{/* Zone based fare sections */}

{/* <Grid item xs={12}>
<Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }}>Zone based fare </Typography>  
</Grid>
<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} > Select zone :</Typography>  
</Grid>
<Grid item xs={8}   style={{ display: "flex", justifyContent: "center" }} >
  <Tooltip 
  title={!formik.values.farezone ? "Enable Zone Fare before You edit" : ""}
  placement="top"
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ff6b6b",   // light red
        color: "#fff",               // white text
        fontSize: "14px",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      },
    },
    arrow: {
      sx: {
        color: "#ff6b6b", // arrow matches tooltip bg
      },
    },
  }}
  arrow
>
<TextField
  name="zonetypes"
  id="zonetypes"
  label="Zones"
  value={formik.values.zonetypes}
  onChange={formik.handleChange}
  select
  disabled={!formik.values.farezone}   // 👈 Disable if switch OFF
  error={formik.touched.zonetypes && Boolean(formik.errors.zonetypes)}
  helperText={formik.touched.zonetypes && formik.errors.zonetypes}
  fullWidth
  variant="outlined"
  size="small"
>
  {addedzone.map((service) => (
    <MenuItem key={service._id} value={service._id}>
      {service.locationName}
    </MenuItem>
  ))}
</TextField>
</Tooltip>
  </Grid> */}

{/* zonepercentage */}
{/* <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Zone price ( % ) :</Typography>  
</Grid>
<Grid item xs={8}   style={{ display: "flex", justifyContent: "center" }} >
<Tooltip 
  title={!formik.values.farezone ? "Enable Zone Fare before You edit" : ""}
  placement="top"
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ff6b6b",   // light red
        color: "#fff",               // white text
        fontSize: "14px",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      },
    },
    arrow: {
      sx: {
        color: "#ff6b6b", // arrow matches tooltip bg
      },
    },
  }}
  arrow
>
<TextField
  name="zonepercentage"
  id="zonepercentage"
  label="Zone price"
  value={formik.values.zonepercentage}
  onChange={formik.handleChange}
  disabled={!formik.values.farezone}   // 👈 Disable if switch OFF
  error={formik.touched.zonepercentage && Boolean(formik.errors.zonepercentage)}
  helperText={formik.touched.zonepercentage && formik.errors.zonepercentage}
  fullWidth
  variant="outlined"
  size="small"
/>
</Tooltip>
  </Grid> */}
{/* surge section */}





  

 









<Grid item xs={12}>
<Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }}>Surge based fare </Typography>  
</Grid>




<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Starting Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<Typography variant="h6" className={classes.tarrifsubheadings} >Surge Hour (One)</Typography>

<Tooltip 
  title={!formik.values.surgeHourone ? "Enable Surge Hour one  before You edit" : ""}
  placement="top"
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ff6b6b",   // light red
        color: "#fff",               // white text
        fontSize: "14px",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      },
    },
    arrow: {
      sx: {
        color: "#ff6b6b", // arrow matches tooltip bg
      },
    },
  }}
  arrow
>
  <span style={{ pointerEvents:  'auto'  }}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.surgeHouronestartingTime}
            onChange={(newValue) => formik.setFieldValue("surgeHouronestartingTime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
             disabled={!formik.values.surgeHourone}
            variant="outlined"
            error={
              formik?.errors?.surgeHouronestartingTime &&
              formik?.touched?.surgeHouronestartingTime
              }
              helperText={
              formik?.errors?.surgeHouronestartingTime &&
              formik?.touched?.surgeHouronestartingTime &&
              formik?.errors?.surgeHouronestartingTime
              }
            size="small" />}
          />
          </span>
          </Tooltip>
</Grid>
<Grid item xs={4}>
<Typography variant="h6" className={classes.tarrifsubheadings} >Surge Hour (Two)</Typography>
  <Tooltip 
  title={!formik.values.surgeHourtwo ? "Enable Surge Hour Two  before You edit" : ""}
  placement="top"
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ff6b6b",   // light red
        color: "#fff",               // white text
        fontSize: "14px",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      },
    },
    arrow: {
      sx: {
        color: "#ff6b6b", // arrow matches tooltip bg
      },
    },
  }}
  arrow
>
  <span style={{ pointerEvents:  'auto'  }}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.surgerHourtwostartingTime}
            onChange={(newValue) => formik.setFieldValue("surgerHourtwostartingTime", newValue)}
            renderInput={(params) => <TextField {...params}
            fullWidth 
            disabled={!formik.values.surgeHourtwo}
            variant="outlined"
            error={
              formik?.errors?.surgerHourtwostartingTime &&
              formik?.touched?.surgerHourtwostartingTime
              }
              helperText={
              formik?.errors?.surgerHourtwostartingTime &&
              formik?.touched?.surgerHourtwostartingTime &&
              formik?.errors?.surgerHourtwostartingTime
              }
            size="small" />}
          /></span>
          </Tooltip>
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Ending Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
  <Tooltip 
  title={!formik.values.surgeHourone ? "Enable Surge Hour one  before You edit" : ""}
  placement="top"
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ff6b6b",   // light red
        color: "#fff",               // white text
        fontSize: "14px",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      },
    },
    arrow: {
      sx: {
        color: "#ff6b6b", // arrow matches tooltip bg
      },
    },
  }}
  arrow
>
  <span style={{ pointerEvents:  'auto'  }}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.surgeHouroneendingTime}
            onChange={(newValue) => formik.setFieldValue("surgeHouroneendingTime", newValue)}
            renderInput={(params) => <TextField {...params}
            fullWidth 
             disabled={!formik.values.surgeHourone}
            variant="outlined"
            error={
              formik?.errors?.surgeHouroneendingTime &&
              formik?.touched?.surgeHouroneendingTime
              }
              helperText={
              formik?.errors?.surgeHouroneendingTime &&
              formik?.touched?.surgeHouroneendingTime &&
              formik?.errors?.surgeHouroneendingTime
              }
            size="small" />}
          /></span></Tooltip>
</Grid>
<Grid item xs={4}>
  <Tooltip 
  title={!formik.values.surgeHourtwo ? "Enable Surge Hour Two  before You edit" : ""}
  placement="top"
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ff6b6b",   // light red
        color: "#fff",               // white text
        fontSize: "14px",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      },
    },
    arrow: {
      sx: {
        color: "#ff6b6b", // arrow matches tooltip bg
      },
    },
  }}
  arrow
>
  <span style={{ pointerEvents:  'auto'  }}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.surgerHourtwoendingTime}
            onChange={(newValue) => formik.setFieldValue("surgerHourtwoendingTime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            disabled={!formik.values.surgeHourtwo}
            variant="outlined"
            error={
              formik?.errors?.surgerHourtwoendingTime &&
              formik?.touched?.surgerHourtwoendingTime
              }
              helperText={
              formik?.errors?.surgerHourtwoendingTime &&
              formik?.touched?.surgerHourtwoendingTime &&
              formik?.errors?.surgerHourtwoendingTime
              }
            size="small" />}
          /></span>
          </Tooltip>
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Percentage : </Typography>
</Grid>
<Grid item xs={4}>
  <Tooltip 
  title={!formik.values.surgeHourone ? "Enable Surge Hour one  before You edit" : ""}
  placement="top"
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ff6b6b",   // light red
        color: "#fff",               // white text
        fontSize: "14px",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      },
    },
    arrow: {
      sx: {
        color: "#ff6b6b", // arrow matches tooltip bg
      },
    },
  }}
  arrow
>
  <TextField
name="surgeHouronepercentage"
id="surgeHouronepercentage"
label="Percentage"
value={formik?.values?.surgeHouronepercentage}
defaultValue={formik?.values?.surgeHouronepercentage}
 disabled={!formik.values.surgeHourone}
onChange={formik.handleChange}
error={
formik?.errors?.surgeHouronepercentage &&
formik?.touched?.surgeHouronepercentage
}
helperText={
formik?.errors?.surgeHouronepercentage &&
formik?.touched?.surgeHouronepercentage &&
formik?.errors?.surgeHouronepercentage
}
fullWidth
variant="outlined"
size="small"
></TextField></Tooltip>
  </Grid>
  <Grid item xs={4}>
    <Tooltip 
  title={!formik.values.surgeHourtwo ? "Enable Surge Hour Two  before You edit" : ""}
  placement="top"
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ff6b6b",   // light red
        color: "#fff",               // white text
        fontSize: "14px",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      },
    },
    arrow: {
      sx: {
        color: "#ff6b6b", // arrow matches tooltip bg
      },
    },
  }}
  arrow
>
  <TextField
name="surgerHourtwopercentage"
id="surgerHourtwopercentage"
label="Percentage"
disabled={!formik.values.surgeHourtwo}
value={formik?.values?.surgerHourtwopercentage}
defaultValue={formik?.values?.surgerHourtwopercentage}
onChange={formik.handleChange}
error={
formik?.errors?.surgerHourtwopercentage &&
formik?.touched?.surgerHourtwopercentage
}
helperText={
formik?.errors?.surgerHourtwopercentage &&
formik?.touched?.surgerHourtwopercentage &&
formik?.errors?.surgerHourtwopercentage
}
fullWidth
variant="outlined"
size="small"
></TextField></Tooltip>
  </Grid>


{/* <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Percentage : </Typography>
</Grid>
<Grid item xs={4}>
  <TextField
name="surgeHouronepercentage"
id="surgeHouronepercentage"
label="Percentage"
value={formik?.values?.surgeHouronepercentage}
defaultValue={formik?.values?.surgeHouronepercentage}
onChange={formik.handleChange}
error={
formik?.errors?.surgeHouronepercentage &&
formik?.touched?.surgeHouronepercentage
}
helperText={
formik?.errors?.surgeHouronepercentage &&
formik?.touched?.surgeHouronepercentage &&
formik?.errors?.surgeHouronepercentage
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="surgerHourtwopercentage"
id="surgerHourtwopercentage"
label="Percentage"
value={formik?.values?.surgerHourtwopercentage}
defaultValue={formik?.values?.surgerHourtwopercentage}
onChange={formik.handleChange}
error={
formik?.errors?.surgerHourtwopercentage &&
formik?.touched?.surgerHourtwopercentage
}
helperText={
formik?.errors?.surgerHourtwopercentage &&
formik?.touched?.surgerHourtwopercentage &&
formik?.errors?.surgerHourtwopercentage
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>

{/* surge sections */}

{/* <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Starting Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<Typography variant="h6" className={classes.tarrifsubheadings} >Surge Hour (One)</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.surgeHouronestartingTime}
            onChange={(newValue) => formik.setFieldValue("surgeHouronestartingTime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.surgeHouronestartingTime &&
              formik?.touched?.surgeHouronestartingTime
              }
              helperText={
              formik?.errors?.surgeHouronestartingTime &&
              formik?.touched?.surgeHouronestartingTime &&
              formik?.errors?.surgeHouronestartingTime
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<Typography variant="h6" className={classes.tarrifsubheadings} >Surge Hour (Two)</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.surgerHourtwostartingTime}
            onChange={(newValue) => formik.setFieldValue("surgerHourtwostartingTime", newValue)}
            renderInput={(params) => <TextField {...params}
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.surgerHourtwostartingTime &&
              formik?.touched?.surgerHourtwostartingTime
              }
              helperText={
              formik?.errors?.surgerHourtwostartingTime &&
              formik?.touched?.surgerHourtwostartingTime &&
              formik?.errors?.surgerHourtwostartingTime
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Ending Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.surgeHouroneendingTime}
            onChange={(newValue) => formik.setFieldValue("surgeHouroneendingTime", newValue)}
            renderInput={(params) => <TextField {...params}
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.surgeHouroneendingTime &&
              formik?.touched?.surgeHouroneendingTime
              }
              helperText={
              formik?.errors?.surgeHouroneendingTime &&
              formik?.touched?.surgeHouroneendingTime &&
              formik?.errors?.surgeHouroneendingTime
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.surgerHourtwoendingTime}
            onChange={(newValue) => formik.setFieldValue("surgerHourtwoendingTime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.surgerHourtwoendingTime &&
              formik?.touched?.surgerHourtwoendingTime
              }
              helperText={
              formik?.errors?.surgerHourtwoendingTime &&
              formik?.touched?.surgerHourtwoendingTime &&
              formik?.errors?.surgerHourtwoendingTime
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider> */}

{/* <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Percentage : </Typography>
</Grid>
<Grid item xs={4}>
  <TextField
name="surgeHouronepercentage"
id="surgeHouronepercentage"
label="Percentage"
value={formik?.values?.surgeHouronepercentage}
defaultValue={formik?.values?.surgeHouronepercentage}
onChange={formik.handleChange}
error={
formik?.errors?.surgeHouronepercentage &&
formik?.touched?.surgeHouronepercentage
}
helperText={
formik?.errors?.surgeHouronepercentage &&
formik?.touched?.surgeHouronepercentage &&
formik?.errors?.surgeHouronepercentage
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="surgerHourtwopercentage"
id="surgerHourtwopercentage"
label="Percentage"
value={formik?.values?.surgerHourtwopercentage}
defaultValue={formik?.values?.surgerHourtwopercentage}
onChange={formik.handleChange}
error={
formik?.errors?.surgerHourtwopercentage &&
formik?.touched?.surgerHourtwopercentage
}
helperText={
formik?.errors?.surgerHourtwopercentage &&
formik?.touched?.surgerHourtwopercentage &&
formik?.errors?.surgerHourtwopercentage
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid> */}

{/* Add Fare button */}      
<Grid item xs={12} className={classes.sbtBtnWrapper}>
<Button variant="contained" onClick={formik?.handleSubmit} >
Add Fare Model
</Button>
</Grid>

</Grid>

</DialogContent>

<Divider />
<DialogActions>
<section className={classes.dialogActions}>
<section className={classes.closeBtn}>
<Button onClick={handleClose}>Close</Button>
</section>
</section>
</DialogActions>
</Dialog>
    </>
  );
};

export default Servicetypecreate;
